import React from "react";
import Vouchers from "./vouchersWrapper/Vouchers";

export default function VouchersWrapper({ vouchers, GET_VOUCHERS, REMOVE_VOUCHER }){
    let props = {
        vouchers, 
        GET_VOUCHERS,
        REMOVE_VOUCHER,
    };

    return <Vouchers props={props}/>
}


// WEBPACK FOOTER //
// ./src/components/general/VouchersWrapper.jsx